"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLog = void 0;
var common_core_1 = require("@moralisweb3/common-core");
var logDecoderUtils_1 = require("../utils/logDecoderUtils");
var mapping_1 = require("../mapping");
var parseLog = function (webhookData) {
    if (!(0, logDecoderUtils_1.isWebhook)(webhookData)) {
        throw new common_core_1.MoralisStreamError({
            code: common_core_1.StreamErrorCode.GENERIC_STREAM_ERROR,
            message: 'Cannot decode the logs. No logs found in the webhook, or invalid webhook provided.',
        });
    }
    if (!(0, logDecoderUtils_1.hasAbis)(webhookData)) {
        throw new common_core_1.MoralisStreamError({
            code: common_core_1.StreamErrorCode.GENERIC_STREAM_ERROR,
            message: 'Cannot decode the logs. No abis found in the provided webhook.',
        });
    }
    var logs = webhookData.logs, abi = webhookData.abi;
    var decodedLogs = [];
    logs.forEach(function (currentLog) {
        var params = new mapping_1.LogParser(abi).read(currentLog).params;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var decodedLog = {};
        for (var key in params) {
            if (Object.prototype.hasOwnProperty.call(params, key)) {
                var element = params[key];
                decodedLog[key] = element.value;
            }
        }
        decodedLogs.push(decodedLog);
    });
    return decodedLogs;
};
exports.parseLog = parseLog;
//# sourceMappingURL=logParser.js.map